(function (globalScope, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (globalScope) globalScope.CernirCustomStrapFinishingHardwareData = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const DATA = Object.freeze({
  "version": "demo-v1.0.0",
  "defaults": {
    "tipShape": "regular-pointed",
    "edgeFinishing": "painted-edges",
    "edgeColour": "on-tone",
    "springBars": "quick-release-spring-bars"
  },
  "tipShapes": [
    {
      "id": "regular-pointed",
      "title": "Regular (pointed)",
      "helperText": "Gently pointed. Traditional.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "regular-pointed"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "square",
      "title": "Square",
      "helperText": "Straight cut. Modern.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "square"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "oval",
      "title": "Oval",
      "helperText": "Rounded. Soft, vintage feel.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "oval"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "pilot",
      "title": "Pilot",
      "helperText": "Broad point, aviation style.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "pilot"
      },
      "disabled": false,
      "priceModifier": null
    }
  ],
  "tipShapeRouting": {
    "hiddenForStyle": [
      "pilot"
    ],
    "derivedForStyle": {
      "pilot": "pilot"
    }
  },
  "edgeFinishing": [
    {
      "id": "painted-edges",
      "title": "Painted Edges",
      "helperText": "Hand-painted edge. Slim and crisp.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "painted-edges"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "folded-edges",
      "title": "Folded Edges",
      "helperText": "Leather wrapped over the edge.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "folded-edges"
      },
      "disabled": false,
      "priceModifier": null
    }
  ],
  "edgeColours": [
    {
      "id": "on-tone",
      "title": "On tone",
      "helperText": "Paint the strap edge On tone.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "on-tone"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "black",
      "title": "Black",
      "helperText": "Paint the strap edge Black.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "black"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "white",
      "title": "White",
      "helperText": "Paint the strap edge White.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "white"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "red",
      "title": "Red",
      "helperText": "Paint the strap edge Red.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "red"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "dark-green",
      "title": "Dark Green",
      "helperText": "Paint the strap edge Dark Green.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "dark-green"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "blue",
      "title": "Blue",
      "helperText": "Paint the strap edge Blue.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "blue"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "yellow",
      "title": "Yellow",
      "helperText": "Paint the strap edge Yellow.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "yellow"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "turquoise",
      "title": "Turquoise",
      "helperText": "Paint the strap edge Turquoise.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "turquoise"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "dark-pink",
      "title": "Dark Pink",
      "helperText": "Paint the strap edge Dark Pink.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "dark-pink"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "light-grey",
      "title": "Light Grey",
      "helperText": "Paint the strap edge Light Grey.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "light-grey"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "grey",
      "title": "Grey",
      "helperText": "Paint the strap edge Grey.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "grey"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "dark-red",
      "title": "Dark Red",
      "helperText": "Paint the strap edge Dark Red.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "dark-red"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "dark-olive",
      "title": "Dark Olive",
      "helperText": "Paint the strap edge Dark Olive.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "dark-olive"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "light-green",
      "title": "Light Green",
      "helperText": "Paint the strap edge Light Green.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "light-green"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "purple",
      "title": "Purple",
      "helperText": "Paint the strap edge Purple.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "purple"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "aqua-green",
      "title": "Aqua Green",
      "helperText": "Paint the strap edge Aqua Green.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "aqua-green"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "navy",
      "title": "Navy",
      "helperText": "Paint the strap edge Navy.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "navy"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "golden",
      "title": "Golden",
      "helperText": "Paint the strap edge Golden.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "golden"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "orange",
      "title": "Orange",
      "helperText": "Paint the strap edge Orange.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "orange"
      },
      "disabled": false,
      "priceModifier": null
    }
  ],
  "edgeColourActiveFor": [
    "painted-edges"
  ],
  "compatibility": {
    "foldedEdgesDisallowTipShapes": [
      "pilot"
    ]
  },
  "foldedEdgeRules": {
    "default": {
      "supported": false,
      "surchargeCents": 0
    },
    "families": {
      "alligator": {
        "materialIds": [
          "alligator"
        ],
        "supported": true,
        "surchargeCents": 8000
      },
      "epsom": {
        "materialIds": [
          "epsom"
        ],
        "supported": true,
        "surchargeCents": 5000
      },
      "alran-chevre": {
        "materialIds": [
          "alran-chevre"
        ],
        "supported": true,
        "surchargeCents": 5000
      },
      "togo": {
        "materialIds": [
          "togo"
        ],
        "supported": true,
        "surchargeCents": 5000
      }
    }
  },
  "springBars": [
    {
      "id": "quick-release-spring-bars",
      "title": "Quick Release Spring Bars",
      "helperText": "Swap straps by hand on most watches.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "quick-release-spring-bars"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "regular-spring-bars",
      "title": "Regular Spring Bars",
      "helperText": "No lever. Fitted with a spring-bar tool.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "regular-spring-bars"
      },
      "disabled": false,
      "priceModifier": null
    }
  ],
  "springBarsHiddenForStyles": [
    "fixed-bars",
    "middles-cut"
  ]
});

  function getOptions(field) {
    if (field === 'tipShape') return DATA.tipShapes;
    if (field === 'edgeFinishing') return DATA.edgeFinishing;
    if (field === 'edgeColour') return DATA.edgeColours;
    if (field === 'springBars') return DATA.springBars;
    return [];
  }

  function getOption(field, optionId) {
    return getOptions(field).find((item) => item.id === optionId && !item.disabled) || null;
  }

  function isTipShapeActive(style) {
    return !DATA.tipShapeRouting.hiddenForStyle.includes(style);
  }

  function resolveTipShape(rawState) {
    return DATA.tipShapeRouting.derivedForStyle[rawState.style]
      || getOption('tipShape', rawState.tipShape)?.id
      || null;
  }

  function isEdgeColourActive(edgeFinishing) {
    return DATA.edgeColourActiveFor.includes(edgeFinishing);
  }

  function getFoldedEdgeRule(materialId) {
    for (const [family, rule] of Object.entries(DATA.foldedEdgeRules.families)) {
      if (rule.materialIds.includes(materialId)) return { ...rule, family };
    }
    return { ...DATA.foldedEdgeRules.default, family: null, materialIds: [] };
  }

  function isEdgeFinishingAllowed(edgeFinishing, tipShape, materialId) {
    if (!getOption('edgeFinishing', edgeFinishing)) return false;
    if (edgeFinishing !== 'folded-edges') return true;
    return !DATA.compatibility.foldedEdgesDisallowTipShapes.includes(tipShape)
      && getFoldedEdgeRule(materialId).supported;
  }

  function getEdgeFinishingSurchargeCents(edgeFinishing, materialId) {
    if (edgeFinishing !== 'folded-edges') return 0;
    const rule = getFoldedEdgeRule(materialId);
    return rule.supported ? rule.surchargeCents : 0;
  }

  function normalizeState(rawState, options) {
    const normalized = { ...rawState };
    if (options?.deferWhenMaterialMissing && !normalized.material) return normalized;
    const tipShape = resolveTipShape(normalized);
    if (!isEdgeFinishingAllowed(normalized.edgeFinishing, tipShape, normalized.material)) {
      normalized.edgeFinishing = DATA.defaults.edgeFinishing;
    }
    return normalized;
  }

  function isSpringBarsActive(style) {
    return !DATA.springBarsHiddenForStyles.includes(style);
  }

  return Object.freeze({ DATA, getOptions, getOption, isTipShapeActive, resolveTipShape, isEdgeColourActive, getFoldedEdgeRule, isEdgeFinishingAllowed, getEdgeFinishingSurchargeCents, normalizeState, isSpringBarsActive });
});
